import * as React from 'react'
import { BIBME, SiteState } from '@src/state/site/types'
import { SIGNIN_LINK, SIGNUP_LINK } from '@src/utils/dataTestIds'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import styled from 'styled-components'
import { UnstyledButton } from '../base/Buttons'
import { startAuthFlow } from '@src/state/auth/actions'

const Link = styled(UnstyledButton)<LinkProps>`
  margin: 0 15px;
  color: ${({ theme, site }) =>
    site === BIBME ? theme.colors.white : theme.colors.dark};
  font-size: ${({ theme }) => theme.font.text.size.xs};
  font-weight: 300;
  cursor: pointer;
  &:hover {
    color: #aaa;
  }
`

interface LinkProps {
  site?: SiteState
}

interface SignupAndLoginProps {
  handleSignin: () => void
  handleSignup: () => void
  site?: SiteState
}

export const NAV_SIGNUP = 'nav-signup'
export const NAV_SIGNIN = 'nav-signin'

export const SignupAndLogin: React.FunctionComponent<SignupAndLoginProps> = ({
  handleSignup,
  handleSignin,
  site,
}) => {
  return (
    <React.Fragment>
      <Link onClick={handleSignup} site={site} data-test={SIGNUP_LINK}>
        Create Account
      </Link>
      <Link onClick={handleSignin} site={site} data-test={SIGNIN_LINK}>
        Sign In
      </Link>
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleSignup: () => {
    dispatch(startAuthFlow({ view: 'signup', origin: NAV_SIGNUP }))
  },
  handleSignin: () => {
    dispatch(startAuthFlow({ view: 'signin', origin: NAV_SIGNIN }))
  },
})

export default connect(null, mapDispatchToProps)(SignupAndLogin)



// WEBPACK FOOTER //
// ./src/components/Header/SignupAndLogin.tsx